import { RouteRecordRaw } from 'vue-router';

import { targetLocale } from '@/i18n';

export enum GHRoutes {
  ContentPage = 'contentPage',
  ContentTeamUpPage = 'contentTeamUpPage',
  ContentTeamUpStartPage = 'contentTeamUpStartPage',
  LessonGuidePage = 'lessonGuidePage',
  LessonStepPage = 'lessonStepPage',
  LessonAudioPage = 'lessonAudioPage',
  LessonTakeawaysPage = 'lessonTakeawaysPage',
  LessonFeedbackPage = 'lessonFeedbackPage',
  LessonGroupExercisePage = 'lessonGroupExercisePage',
  GhActivityPage = 'ghActivityPage',
  GhccActivityLoadingPage = 'ghccActivityLoadingPage',
  ActivityModeRedirectPage = 'activityModeRedirectPage',
  InternalError = 'internalError',
  NotFound = 'notFound',
  LearningActivityPage = 'learningActivityPage',
  NotAvailable = 'notAvailable',
}

const ContentPage = () => import('@/pages/ContentPage.vue');
const LessonGuidePage = () => import('@/pages/LessonGuidePage.vue');
const LessonStepPage = () => import('@/pages/LessonStepPage.vue');
const LessonGroupExercisePage = () => import('@/pages/LessonGroupExercisePage.vue');
const ContentTeamUpStartPage = () => import('@/pages/ContentTeamUpStartPage.vue');
const LessonTakeawaysPage = () => import('@/pages/LessonTakeawaysPage.vue');
const LessonFeedbackPage = () => import('@/pages/LessonFeedbackPage.vue');
const GhccActivityLoadingPage = () => import('@/pages/GhccActivityLoadingPage.vue');
const GhActivityPage = () => import('@/pages/GhActivityPage.vue');
const ActivityModeRedirectPage = () => import('@/pages/ActivityModeRedirectPage.vue');
const InternalError = () => import('@/pages/InternalError.vue');
const NotFound = () => import('@/pages/NotFound.vue');
const NotAvailable = () => import('@/pages/NotAvailable.vue');
const LearningActivityPage = () => import('@/pages/LearningActivityPage.vue');

export const routes: RouteRecordRaw[] = [
  {
    path: '/:contentType/:slug',
    name: GHRoutes.ContentPage,
    component: ContentPage,
    props: true,
    beforeEnter: () => {
      document.body.style.overflow = 'visible';
    },
  },
  {
    path: '/:contentType/:slug/guide',
    name: GHRoutes.LessonGuidePage,
    components: {
      default: ContentPage,
      dialog: LessonGuidePage,
    },
    props: true,
    beforeEnter: () => {
      document.body.style.overflow = 'hidden';
    },
  },
  {
    path: '/:contentType/:slug/step/:stepId',
    name: GHRoutes.LessonStepPage,
    components: {
      default: ContentPage,
      dialog: LessonStepPage,
    },
    props: true,
    beforeEnter: () => {
      document.body.style.overflow = 'hidden';
    },
  },
  {
    path: '/:contentType/:slug/audio',
    name: GHRoutes.LessonAudioPage,
    components: {
      default: ContentPage,
    },
    props: true,
    beforeEnter: () => {
      document.body.style.overflow = 'visible';
    },
  },
  {
    path: '/:contentType/:slug/group-exercise',
    name: GHRoutes.LessonGroupExercisePage,
    components: {
      default: LessonGroupExercisePage,
    },
    props: true,
    beforeEnter: () => {
      document.body.style.overflow = 'visible';
    },
  },
  {
    path: '/:contentType/:slug/team-up',
    name: GHRoutes.ContentTeamUpPage,
    components: {
      default: ContentPage,
    },
    props: true,
    beforeEnter: () => {
      document.body.style.overflow = 'visible';
    },
  },
  {
    path: '/:contentType/:slug/team-up/start',
    name: GHRoutes.ContentTeamUpStartPage,
    components: {
      default: ContentPage,
      dialog: ContentTeamUpStartPage,
    },
    props: true,
    beforeEnter: () => {
      document.body.style.overflow = 'hidden';
    },
  },
  {
    path: '/:contentType/:slug/feedback',
    name: GHRoutes.LessonFeedbackPage,
    components: {
      default: ContentPage,
      dialog: LessonFeedbackPage,
    },
    props: true,
    beforeEnter: () => {
      document.body.style.overflow = 'hidden';
    },
  },
  {
    path: '/:contentType/:slug/takeaways',
    name: GHRoutes.LessonTakeawaysPage,
    components: {
      default: ContentPage,
      dialog: LessonTakeawaysPage,
    },
    props: true,
    beforeEnter: () => {
      document.body.style.overflow = 'hidden';
    },
  },
  {
    path: '/:contentType/:slug/ghcc/:activityId',
    name: GHRoutes.GhccActivityLoadingPage,
    components: {
      default: ContentPage,
      dialog: GhccActivityLoadingPage,
    },
    props: true,
    beforeEnter: () => {
      document.body.style.overflow = 'hidden';
    },
  },
  {
    path: '/:contentType/:slug/gh/:activityId',
    name: GHRoutes.GhActivityPage,
    components: {
      default: ContentPage,
      dialog: GhActivityPage,
    },
    props: true,
    beforeEnter: () => {
      document.body.style.overflow = 'hidden';
    },
  },
  {
    path: '/:contentType/:slug/:activityMode/:activityId',
    name: GHRoutes.ActivityModeRedirectPage,
    components: {
      default: ContentPage,
      dialog: ActivityModeRedirectPage,
    },
    props: true,
    beforeEnter: () => {
      document.body.style.overflow = 'hidden';
    },
  },
  {
    path: '/learning-activities/:slug',
    name: GHRoutes.LearningActivityPage,
    component: LearningActivityPage,
    beforeEnter: () => {
      document.body.style.overflow = 'hidden';
    },
  },
  {
    path: '/internal-error',
    name: GHRoutes.InternalError,
    component: InternalError,
  },
  {
    path: '/:contentType/not-available',
    name: GHRoutes.NotAvailable,
    component: NotAvailable,
    props: true,
  },
  {
    path: '/:pathMatch(.*)*',
    name: GHRoutes.NotFound,
    component: NotFound,
    beforeEnter() {
      window.location.href = `${window.location.origin}/${targetLocale}/404.html`;
    },
  },
];
